export default __webpack_public_path__ + "3d477b516cde9b804406fc5414b91b7b.svg";